var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-link',{attrs:{"to":"/"}}),(_vm.routerState)?_c('router-view',{key:_vm.$router.currentRoute.fullPath}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }